'use strict';

export const FONT_WEIGHT_MAPPINGS = {
  thin: '100',
  ultralight: '200',
  light: '300',
  normal: '400',
  regular: '400',
  medium: '500',
  condensed: '500',
  semibold: '600',
  bold: '700',
  condensedBold: '700',
  heavy: '800',
  black: '900'
};
//# sourceMappingURL=font.js.map